"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportType = void 0;
var ExportType;
(function (ExportType) {
    ExportType["behaviorCodeEntry"] = "behaviorCodeEntry";
    ExportType["incident"] = "incidents";
})(ExportType || (exports.ExportType = ExportType = {}));
